import React, { useState, useEffect } from 'react'
import Icons from '../../Constants/Icons'
import i18n from '../Language/i18n'
import Select from 'react-select'
import { useTranslation } from 'react-i18next'

const Header = ({ scrollToSection }) => {
  const [isNavOpen, setIsNavOpen] = useState(false)
  const [language, setLanguage] = useState(() => {
    const savedLang = localStorage.getItem('language')
    return savedLang ? JSON.parse(savedLang) : { value: 'en', label: 'English' }
  })

  const changeLanguage = lng => {
    localStorage.setItem('language', JSON.stringify(lng))
    setLanguage(lng)
    i18n.changeLanguage(lng.value)
  }
  useEffect(() => {
    i18n.changeLanguage(language.value)
  }, [language])

  const options = [
    { value: 'en', label: 'English' },
    { value: 'fr', label: 'French' }
  ]
  const { t } = useTranslation()

  return (
    <header className='main-header main-header-overlay'>
      <div className='mainbar-wrap'>
        <div className='megamenu-hover-bg'></div>
        <div className='container-fluid mainbar-container'>
          <div className='mainbar'>
            <div className='row mainbar-row align-items-lg-stretch'>
              <div className='col-auto'>
                <div className='navbar-header'>
                  <a className='navbar-brand' href='#'>
                    <span className='navbar-brand-inner'>
                      <img
                        className='mobile-logo-default'
                        src={Icons.logo}
                        alt='logo'
                      />
                      <img
                        className='logo-default'
                        src={Icons.logo}
                        alt='logo'
                      />
                    </span>
                  </a>
                  <button
                    type='button'
                    className='navbar-toggle collapsed nav-trigger style-mobile'
                    onClick={() => setIsNavOpen(!isNavOpen)}
                    aria-expanded={isNavOpen}
                  >
                    <span className='menu_icons'>
                      <span></span>
                      <span></span>
                      <span></span>
                    </span>
                  </button>
                </div>
              </div>
              <div className='col pr-8 pl-9'>
                <div
                  className={`collapse navbar-collapse ${
                    isNavOpen ? 'show' : ''
                  }`}
                >
                  <ul
                    id='primary-nav'
                    className='main-nav nav align-items-lg-stretch justify-content-lg-start'
                  >
                    {[
                      { label: 'Property Estimate', id: '#homeestimate' },
                      { label: 'Cash Offers', id: '#cashoffers' },
                      { label: 'MLS', id: '#centrisMLS' },
                      // { label: 'Buyer’s', id: '#buyers' },
                      { label: 'About us', id: '#aboutus' },
                      // { label: 'Partner’s', id: '#partners' },
                      { label: 'Reviews', id: '#reviews' }
                    ].map((item, index) => (
                      <li
                        onClick={label => scrollToSection(item.label)}
                        key={index}
                        className='nav-item'
                        style={{ cursor: 'pointer' }}
                      >
                        <a data-id={item.id} className='nav-link'>
                          <span className='link-txt'>
                            <span className='txt' style={{ fontWeight: '700' }}>
                              {t(item.label)}
                            </span>
                          </span>
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              <div className='col-auto text-right bl-fade-white-02 pl-md-6'>
                <div className='header-module'>
                  <p className='text-right leading-relaxed'>
                    <span className='text-fade-white-05 text-sm font-size-14'>
                      {t('Write us for any question')}
                    </span>
                    <br />
                    <span className='text-lg text-primary'>
                      <a
                        href='mailto:vendu@maisonsdirect.ca'
                        className='text-primary font-size-18'
                      >
                        <strong>{t('vendu@maisonsdirect.ca')}</strong>
                      </a>
                    </span>
                    <br></br>
                    <span className='text-fade-white-05 text-sm font-size-20'>
                      {t('+1 514-898-8000')}
                    </span>
                    <div style={{}}>
                      <Select
                        options={options}
                        defaultValue={options[0]}
                        onChange={changeLanguage}
                        value={language}
                      />
                    </div>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  )
}

export default Header
